import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

import {financingRateSchema} from '../schemas/financingRateSchema';

/**
 * Whether a money amount may be sent. A cleared amount is valid; a present one has to satisfy the
 * same rule the money inputs surface, so the save gate and the input agree on what is acceptable.
 */
export function isValidMoneyAmount(money: {amount: string} | Nullish) {
  return isNil(money) || financingRateSchema.safeParse(Number(money.amount)).success;
}
